import Measurement from './Measurement.vue'
import Gene from './Gene.vue'
import Exposure from './Exposure.vue'

export default [
  {
    path: '/database',
    redirect: '/measurement'
  },
  {
    path: '/measurement',
    name: 'MeasurementSelection',
    component: Measurement
  },
  {
    path: '/measurement/:analysisType',
    name: 'MeasurementAnalysis',
    component: Measurement
  },
  {
    path: '/gene',
    name: 'GeneSelection',
    component: Gene
  },
  {
    path: '/gene/:analysisType',
    name: 'GeneAnalysis',
    component: Gene
  },
  {
    path: '/exposure',
    name: 'ExposureSelection',
    component: Exposure
  },
  {
    path: '/exposure/:analysisType',
    name: 'ExposureAnalysis',
    component: Exposure
  }
]
